import axios, { InternalAxiosRequestConfig } from "axios"
import { getEnv } from "../../../../utils/env"
import { firebaseauth as auth } from "../../../mp-database/firebaseConfig"

// Pentest finding #3: Cloud Functions now require a Firebase ID token.
// Kept out of Headers/index.ts so importing custom headers doesn't pull in
// Firebase auth.

// Python Cloud Functions are served from the same root (CLOUD_FUNCTION_PYTHON_ROOT
// is also <lb>/gcf) but their CORS only allows Content-Type, so adding an
// Authorization header makes the browser block the request after preflight.
// They don't verify Firebase ID tokens, so leave them out.
const PYTHON_FUNCTIONS = ["get_next_adaptive_item"]

const isPythonFunctionUrl = (url: string): boolean => {
  const path = url.split("?")[0]

  return PYTHON_FUNCTIONS.some(name => path.endsWith(`/${name}`))
}

export const isCloudFunctionUrl = (url?: string): boolean => {
  const root = getEnv("CLOUD_FUNCTION_ROOT")

  return !!url && !!root && url.startsWith(root) && !isPythonFunctionUrl(url)
}

export const getCloudFunctionAuthHeaders = async (): Promise<
  Record<string, string>
> => {
  const token = await auth.currentUser?.getIdToken(false)

  return token
    ? { Authorization: `Bearer ${token}`, "auth-provider": "firebase" }
    : {}
}

// Adds the signed-in user's ID token to default-axios calls to Cloud
// Functions that don't already set Authorization.
export const attachCloudFunctionAuth = (): void => {
  axios.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      if (isCloudFunctionUrl(config.url) && !config.headers.has("Authorization")) {
        const headers = await getCloudFunctionAuthHeaders()

        Object.entries(headers).forEach(([key, value]) => {
          config.headers.set(key, value)
        })
      }

      return config
    }
  )
}
